export default __webpack_public_path__ + "static/media/Summoner's Robes of Regal Might.a80e0a13.jpg";